import { render, staticRenderFns } from "./FormsOverview.vue?vue&type=template&id=e588cd16&scoped=true&"
import script from "./FormsOverview.vue?vue&type=script&lang=ts&"
export * from "./FormsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e588cd16",
  null
  
)

export default component.exports